"use client";

import { memo } from "react";
import clsx from "clsx";
import Text from "@/component/ui/Text";

interface ItemProps {
  id: number;
  title: string;
  summary?: string;
  flag?: boolean;
  flagHref?: string;
  price?: string;
  priceTag?: string;
}

interface SelectLabelProps {
  item: ItemProps;
  onClick?: () => void;
  active?: boolean;
  className?: string;
  recommended?: boolean
}

const SelectLabel = memo(({ item, onClick, active = false, className, recommended = false}: SelectLabelProps) => {
  const showFlag = item.flag && item.flagHref;
  const showPrice = item.price || item.priceTag;

  return (
    <div
      onClick={onClick}
      className={clsx(
        "p-4 border rounded-lg cursor-pointer transition-all duration-200",
        "hover:border-brand hover:bg-brandlight",
        active ? "border-brand bg-brandlight" : 'border-graylight bg-white',
        className
      )}
    >
      <div className={clsx(
          "flex justify-between",
          recommended ? "items-center" : 'items-start'
      )}>
        <div className="flex items-center gap-2">
          <span
            className={clsx(
              "w-3.5 h-3.5 rounded-full border bg-white flex items-center justify-center ",
              active ? "border-brand" : 'border-gray'
            )}
          >
            {active && <span className="w-2.5 h-2.5 bg-brand rounded-full" />}
          </span>
          <Text fontType="sub_title">{item.title}</Text>
        </div>

        {showFlag ? (
          <img src={item.flagHref} alt="flag" className="w-6 h-auto" />
        ) : (
          showPrice && (
            <Text fontType="sub_title">
              {item.priceTag}
              {item.price}
            </Text>
          )
        )}
        {recommended && <div className=" flex items-center justify-center bg-activelight text-active px-2 py-1.5 border border-active rounded-full">
          <Text fontType="small_paragraph">Recommended</Text>
        </div>}
      </div>

      <Text fontType="paragraph" as="div" className={clsx(
          "text-darkgray",
          item?.summary ? 'mt-3' : ''
      )}>
        {item.summary}
      </Text>
    </div>
  );
});

SelectLabel.displayName = "SelectLabel";

export default SelectLabel;
